<dgx-panel-list
  [collectionName]="i18n.LearningSearch_People"
  [isLoading]="isLoading"
  [totalNumItems]="totalNumItems"
  [maxDisplayedItems]="5"
  [linkData]="linkData"
>
  <ul>
    <li
      *ngFor="let item of items; trackBy: trackByFn"
      data-dgat="search-people-7af"
    >
      <!--dgx-list-item is our item template that provides ng-content placeholders for a left-justified icon and a right-justified button (or whatever you want to stick there).
    Here, we're just providing the icon and "follow" button--the custom parts. The item layout, title and description are all pre-packaged in the list item component and reused everywhere-->
      <dgx-list-item [item]="item" [alignTop]="true">
        <!--Item icon-->
        <ng-container icon>
          <dgx-profile-pic
            [profile]="item.model"
            size="small"
            class="guts-p-t-quart block"
          ></dgx-profile-pic>
        </ng-container>

        <!--Item end button-->
        <button
          button
          df-button
          df-button-square
          *ngIf="!getIsAuthorizedUser(item.model.userProfileKey)"
          [dfButtonType]="getButtonType(item.model.isFollowing)"
          class="guts-m-t-quart block"
          (click)="doFollowAction(item)"
          [attr.aria-label]="
            getButtonAriaLabel(item.model.isFollowing, item.model.name)
          "
          data-dgat="search-people-d62"
        >
          <df-icon
            [icon]="getButtonIcon(item.model.isFollowing)"
            size="small"
            class="center-text"
          ></df-icon>
        </button>
      </dgx-list-item>
    </li>
  </ul>
</dgx-panel-list>

<dgx-search-sidebar-no-results
  *ngIf="showNoResults"
  [collectionName]="i18n.LearningSearch_People"
></dgx-search-sidebar-no-results>

<dgx-search-sidebar-error
  *ngIf="showError"
  [collectionName]="i18n.LearningSearch_People"
></dgx-search-sidebar-error>
